export interface BlogPostData {
  slug: string;
  title: string;
  excerpt: string;
  date: string;
  readTime: string;
  category: string;
}

export const blogPosts: BlogPostData[] = [
  // AirPods Microphone Setup Guide 2026 (Latest)
  {
    slug: 'airpods-microphone-setup-guide-2026',
    title: 'AirPods Microphone Setup Guide 2026: Complete Configuration for Calls, Vlogging & Recording',
    excerpt: 'Master AirPods microphone settings for crystal-clear calls, professional vlogging, and high-quality recordings. Complete 2026 guide with iOS 19 features and pro tips.',
    date: '2026-01-14',
    readTime: '15 min read',
    category: 'AirPods Tips',
  },
  // iPhone 16 Problems Guide (Latest 2026)
  {
    slug: 'iphone-16-common-problems-fix-patna',
    title: 'iPhone 16 Common Problems & Solutions: Complete Repair Guide for Patna',
    excerpt: 'Experiencing iPhone 16 issues? From display problems to camera glitches, learn DIY fixes and when to visit iFix Apple Care Patna for professional iPhone 16 repair.',
    date: '2026-01-13',
    readTime: '18 min read',
    category: 'iPhone Problems',
  },
  // Latest Apple Tips & Guides (2026)
  {
    slug: 'iphone-data-backup-icloud-tips-bihar',
    title: 'iPhone Data Backup & iCloud Storage Tips: Complete Guide for Bihar Users',
    excerpt: 'Master iPhone data backup and iCloud storage with local internet considerations. Learn secure backup strategies, iCloud optimization, and data security tips for Patna users.',
    date: '2026-01-08',
    readTime: '18 min read',
    category: 'iPhone Tips',
  },
  {
    slug: 'iphone-battery-life-charging-hygiene-patna',
    title: 'iPhone Battery Life & Charging Hygiene: Complete Guide for Patna Users',
    excerpt: 'Learn proper iPhone charging practices, battery health tips, and local charging habits affecting battery life in Bihar. Expert advice from iFix Apple Care Patna.',
    date: '2026-01-07',
    readTime: '16 min read',
    category: 'iPhone Tips',
  },
  {
    slug: 'iphone-camera-tips-professional-photos',
    title: 'iPhone Camera Tips: Capture Professional Photos Like a Pro in Bihar',
    excerpt: 'Master your iPhone camera with expert tips for stunning photos. Learn ProRAW, Portrait mode, Night mode, and hidden features for photographers in Patna.',
    date: '2026-01-06',
    readTime: '14 min read',
    category: 'iPhone Tips',
  },
  {
    slug: 'best-iphone-screen-settings-for-eyes',
    title: '8 Best iPhone Screen Settings for Your Eyes - Reduce Eye Strain',
    excerpt: 'Discover the best iPhone display settings to protect your eyes. Learn about Night Shift, True Tone, and accessibility features to reduce eye strain.',
    date: '2026-01-05',
    readTime: '8 min read',
    category: 'iPhone Tips',
  },
  {
    slug: 'airpods-microphone-video-vlogging-guide',
    title: 'AirPods as Microphone for Video Vlogging - Complete Setup Guide',
    excerpt: 'Learn how to use your AirPods as a professional microphone for video vlogging. Best settings and tips for content creators in Bihar.',
    date: '2026-01-04',
    readTime: '10 min read',
    category: 'AirPods Tips',
  },
  {
    slug: 'apple-pencil-iphone-fold-compatibility',
    title: 'Will Apple Pencil Work with iPhone Fold? Everything We Know',
    excerpt: 'Exploring Apple Pencil compatibility with the rumored iPhone Fold. What we know about Apple stylus support on foldable iPhones.',
    date: '2026-01-03',
    readTime: '6 min read',
    category: 'Apple News',
  },
  {
    slug: 'apple-fitness-plus-2026-announcement',
    title: 'Apple Teases "Something Big" Coming to Apple Fitness+ 2026',
    excerpt: 'Apple hints at major Apple Fitness+ updates for 2026. AI-powered workouts, new trainers, and revolutionary features expected.',
    date: '2026-01-02',
    readTime: '7 min read',
    category: 'Apple News',
  },
  {
    slug: 'track-flight-on-iphone-guide',
    title: 'How to Track a Flight on Your iPhone - Complete Guide for Bihar Travelers',
    excerpt: 'Learn multiple ways to track flights on iPhone using Siri, Messages, Maps, and apps. Perfect guide for travelers from Patna Airport.',
    date: '2026-01-01',
    readTime: '8 min read',
    category: 'iPhone Tips',
  },
  {
    slug: 'iphone-ask-why-calling-feature',
    title: 'Your iPhone Can Ask Why Someone Is Calling Before You Pick Up',
    excerpt: 'Discover the new iOS feature that asks callers to state their purpose. Reduce spam calls and know who is calling before answering.',
    date: '2025-12-30',
    readTime: '6 min read',
    category: 'iPhone Tips',
  },
  {
    slug: 'edge-light-better-video-calls-macos',
    title: 'Use Edge Light for Better Video Calls on macOS - Pro Tips',
    excerpt: 'Master edge lighting on your MacBook for professional video calls. Tips for remote workers and content creators in Bihar.',
    date: '2025-12-28',
    readTime: '9 min read',
    category: 'MacBook Tips',
  },
  {
    slug: 'iphone-control-center-apple-watch',
    title: 'Use iPhone Control Center on Apple Watch - Complete Setup Guide',
    excerpt: 'Learn how to access iPhone Control Center directly from your Apple Watch. Control your iPhone remotely with these easy steps.',
    date: '2025-12-26',
    readTime: '7 min read',
    category: 'Apple Watch Tips',
  },
  {
    slug: 'ios26-real-time-call-translation',
    title: 'iOS 26 Translate Phone Calls in Real Time on iPhone',
    excerpt: 'iOS 26 brings real-time call translation to iPhone. Make calls in any language with automatic AI-powered translation.',
    date: '2025-12-24',
    readTime: '8 min read',
    category: 'iOS Updates',
  },
  {
    slug: 'iphone-17-new-features-guide',
    title: 'Got New iPhone 17? How to Use All the New Features',
    excerpt: 'Complete guide to iPhone 17 new features. Camera Control, Action Button, AI features, and tips to maximize your new iPhone.',
    date: '2025-12-22',
    readTime: '15 min read',
    category: 'iPhone Tips',
  },
  {
    slug: 'ios-26-2-features-everything-new',
    title: 'iOS 26.2 Features - Everything New in iOS 26.2 Update',
    excerpt: 'Comprehensive guide to all new features in iOS 26.2. Bug fixes, performance improvements, and hidden features explained.',
    date: '2025-12-20',
    readTime: '12 min read',
    category: 'iOS Updates',
  },
  {
    slug: 'apple-newest-macbook-pro-at-a-glance',
    title: 'Apple Newest MacBook Pro at a Glance - M4 Pro & M4 Max Review',
    excerpt: 'Complete overview of Apple latest MacBook Pro with M4 chips. Performance, features, and why it matters for professionals in Bihar.',
    date: '2025-12-18',
    readTime: '11 min read',
    category: 'MacBook Tips',
  },
  {
    slug: 'why-apple-authorized-service-no-chip-level-repair',
    title: 'Why Apple Authorized Service Centers Do Not Do Chip Level Repairing?',
    excerpt: 'Understanding why Apple service centers avoid chip-level repairs. Learn about iFix Apple Care expertise in motherboard repairs in Patna.',
    date: '2025-12-16',
    readTime: '10 min read',
    category: 'Repair Insights',
  },
  // Long-form iPhone problem guides
  {
    slug: 'iphone-battery-draining-fast-fix-patna',
    title: 'iPhone Battery Draining Fast? Complete Fix Guide for Patna Users',
    excerpt: 'Is your iPhone battery draining quickly? Learn the causes, DIY fixes, and when to visit iFix Apple Care in Patna for professional battery replacement.',
    date: '2024-12-18',
    readTime: '12 min read',
    category: 'iPhone Problems',
  },
  {
    slug: 'iphone-not-charging-solutions-bihar',
    title: 'iPhone Not Charging? 10 Solutions + Professional Repair in Bihar',
    excerpt: 'Complete troubleshooting guide for iPhone charging issues. From cleaning the port to logic board repair, learn all solutions available in Patna.',
    date: '2024-12-17',
    readTime: '15 min read',
    category: 'iPhone Problems',
  },
  {
    slug: 'iphone-overheating-causes-fix-patna',
    title: 'iPhone Overheating: Causes, Dangers & Expert Repair in Patna',
    excerpt: 'Why is your iPhone getting hot? Understand the causes of iPhone overheating and get professional repair solutions at iFix Apple Care, Patna.',
    date: '2024-12-16',
    readTime: '14 min read',
    category: 'iPhone Problems',
  },
  {
    slug: 'iphone-face-id-not-working-repair-bihar',
    title: 'iPhone Face ID Not Working? Complete Repair Guide for Bihar',
    excerpt: 'Face ID stopped working on your iPhone? Learn the causes, troubleshooting steps, and professional repair options in Patna, Bihar.',
    date: '2024-12-14',
    readTime: '11 min read',
    category: 'iPhone Problems',
  },
  {
    slug: 'iphone-water-damage-recovery-patna',
    title: 'iPhone Water Damage Recovery - Emergency Repair Service in Patna',
    excerpt: 'Dropped your iPhone in water? Act fast! Learn immediate steps and get emergency water damage repair at iFix Apple Care, Patna.',
    date: '2024-12-13',
    readTime: '13 min read',
    category: 'iPhone Problems',
  },
  // Original service pages
  {
    slug: 'iphone-screen-repair-patna-bihar',
    title: 'Best iPhone Screen Repair Service in Patna, Bihar - Same Day Fix',
    excerpt: 'Looking for reliable iPhone screen repair in Patna? iFix Apple Care offers same-day screen replacement for all iPhone models with genuine parts and warranty.',
    date: '2024-12-15',
    readTime: '5 min read',
    category: 'iPhone Repair',
  },
  {
    slug: 'macbook-repair-service-bihar',
    title: 'Professional MacBook Repair Service in Bihar - Expert Technicians',
    excerpt: 'Get your MacBook repaired by certified technicians in Patna. We handle screen replacement, battery issues, keyboard repairs, and logic board fixes.',
    date: '2024-12-12',
    readTime: '6 min read',
    category: 'MacBook Repair',
  },
  {
    slug: 'ipad-repair-patna-complete-guide',
    title: 'Complete iPad Repair Guide - Best Service Center in Patna',
    excerpt: 'Comprehensive iPad repair services in Patna, Bihar. From cracked screens to charging issues, our experts fix all iPad models quickly and affordably.',
    date: '2024-12-10',
    readTime: '5 min read',
    category: 'iPad Repair',
  },
  {
    slug: 'apple-watch-repair-bihar',
    title: 'Apple Watch Repair in Bihar - Screen & Battery Replacement',
    excerpt: 'Expert Apple Watch repair services in Patna. We specialize in screen replacement, battery replacement, and sensor repairs for all Watch series.',
    date: '2024-12-08',
    readTime: '4 min read',
    category: 'Apple Watch',
  },
  {
    slug: 'apple-service-center-patna-why-choose-us',
    title: 'Why Choose iFix Apple Care - Best Apple Service Center in Patna',
    excerpt: 'Discover why iFix Apple Care is the most trusted Apple service center in Bihar. Learn about our genuine parts, expert technicians, and customer satisfaction.',
    date: '2024-12-05',
    readTime: '4 min read',
    category: 'About Us',
  },
];

export const getRelatedPosts = (currentSlug: string, category: string, limit: number = 3): BlogPostData[] => {
  // First, get posts from the same category (excluding current post)
  const sameCategoryPosts = blogPosts.filter(
    post => post.slug !== currentSlug && post.category === category
  );
  
  // If we have enough posts from the same category, return them
  if (sameCategoryPosts.length >= limit) {
    return sameCategoryPosts.slice(0, limit);
  }
  
  // Otherwise, fill with other recent posts
  const otherPosts = blogPosts.filter(
    post => post.slug !== currentSlug && post.category !== category
  );
  
  return [...sameCategoryPosts, ...otherPosts].slice(0, limit);
};
